import React from "react";
import ReactDOM from "react-dom";

/**
 * Import static files
 */
import "./index.css";

/**
 * Import Components
 */
import App from "./App";

/**
 * Import Providers
 */
import { FirestoreProvider } from "./contexts/FirestoreProvider";
import { RoomsProvider } from "./contexts/RoomsProvider";
import { GameProvider } from "./contexts/GameProvider";

ReactDOM.render(
  <React.StrictMode>
    <FirestoreProvider>
      <RoomsProvider>
        <GameProvider>
          <App />
        </GameProvider>
      </RoomsProvider>
    </FirestoreProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
